export const BUSINESS_LOGIN = "BUSINESS_LOGIN";
export const PROFILE_DETAIL="PROFILE_DETAIL";